export default __webpack_public_path__ + "static/media/Meta_logo.d404683d.png";